import { useEffect, useState } from "react";

import { DeviceModel } from "src/gen/schema/models/bom";
import { ConfigD } from "src/utils/api/configD";

type Registry<T> = Record<string, T>;

export interface DeviceModelHelper {
  /**
   * Get device model by model name
   * @param model
   */
  getDeviceByModelName: (model: string | undefined) => DeviceModel | undefined;
  /**
   * Get all device models
   */
  getDeviceModels: () => DeviceModel[];
  /**
   * Get all device model names
   */
  getDeviceModelNames: () => string[];
}
export const useDeviceModels = (): DeviceModelHelper => {
  // State to hold the mapping from model name to DeviceModel object
  const [helpers, setDeviceModels] = useState<DeviceModelHelper>({
    getDeviceByModelName: () => undefined,
    getDeviceModels: () => [],
    getDeviceModelNames: () => []
  });

  useEffect(() => {
    const tid = setTimeout(() => {
      ConfigD.getDeviceModels({}).then((resp: DeviceModel[]) => {
        // Create a new Map to store modelName -> DeviceModel mapping
        const deviceModels: Registry<DeviceModel> = {};
        // Iterate over each device model returned by the API
        resp.forEach((d) => {
          // Use modelName as the key and the DeviceModel object as the value
          deviceModels[d.modelName] = d;
        });
        // Update state with the new Map, triggering a re-render
        setDeviceModels({
          getDeviceByModelName: (model: string = "") => deviceModels[model],
          getDeviceModels: () => Object.values(deviceModels),
          getDeviceModelNames: () => Object.keys(deviceModels)
        });
      });
    }, 0);
    return () => clearTimeout(tid);
  }, []);

  // Return the helpers for device models.
  return helpers;
};
